interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-center gap-2 mt-10">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-600 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
      >
        <i className="ri-arrow-left-s-line" />
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`w-9 h-9 flex items-center justify-center rounded-md text-sm font-label transition-colors cursor-pointer ${
            p === page
              ? 'bg-primary-500 text-background-50'
              : 'border border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-600'
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-600 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
      >
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}